import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'portTypePipe'})
export class PortTypePipe implements PipeTransform {
  transform(type: number): string {
    switch(type) {
      case 1: {
        return 'Discrete Input';
      }
      case 2: {
        return 'Descrete Output';
      }
      case 3: {
        return 'Analog Input';
      }
      case 4: {
        return 'Analog Output';
      }
      default: {
        return 'Unknown';
      }
    }
  }
}